import { Component, OnInit, TemplateRef } from '@angular/core';
import {Sort} from '@angular/material/sort';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { ShiftService } from '../shift.service';
import { GenericServiceService } from '../../services/generic-service.service';

@Component({
  selector: 'app-shifts',
  templateUrl: './shifts.component.html',
  styleUrls: ['./shifts.component.scss']
})
export class ShiftsComponent implements OnInit {
  listOfShifts: any = {};
  p = 1;
  cityId;
  model: any = {};
  countryList: any = [];
  cityList: any = [];
  cityObject: any = {};
  modalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private router: Router,
    private shiftServices: ShiftService,
    private genericService: GenericServiceService

  ) { }
  time = {hour: 13, minute: 30};
  meridian = true;

  toggleMeridian() {
      this.meridian = !this.meridian;
  }
  ngOnInit() {
    this.cityId = localStorage.getItem('cityId');
    this.getAllShiftByCityId(this.cityId);
    this.getAllCountries();
  }
  getAllCountries() {
    this.genericService.getAllCountries().subscribe(Response => {
      this.countryList = Response;
    });
  }
  city(id) {
    this.genericService.getCitWithId(id).subscribe(Response => {
      this.cityList = Response;
    });
  }
  shiftsByCityId(cityId) {
    this.genericService.getCitWithCItyId(cityId).subscribe(Response => {
      if (Response) {
       this.cityObject = Response;
       localStorage.setItem('cityId', JSON.stringify(this.cityObject.Id));
       localStorage.setItem('cityName', JSON.stringify(this.cityObject.Name));
       this.getAllShiftByCityId(cityId);
     }
   });
  }
  getAllShiftByCityId(cityId) {
    this.shiftServices.getAllShiftsByCityId(cityId).subscribe(Response => {
      this.listOfShifts = Response;

    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }

  confirm(id): void {
    this.shiftServices.DeleteShift(id).subscribe(Response => {
      this.getAllShiftByCityId(this.cityId);
    });
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }
  AddShifNavigation() {
    this.router.navigateByUrl('/shifts/addShift');
  }
  UpdateType(id) {
    this.router.navigateByUrl('/shifts/updateShift/' + id);

  }
  gotoShiftDetail(id) {
    this.router.navigateByUrl('/shifts/shiftDetail/'  + id);
  }
}
